module.exports = __webpack_public_path__ + "438771653fbb40b97d467f18e1f46582.svg";